import { getEvents } from "core-integration/src/store/events/reducers";
import { FilterChip } from "plos/src/components/Chip";
import { FilterRadioButton } from "plos/src/components/FilterSheet";
import FilterFooter from "plos/src/components/FilterSheet/FilterFooter";
import {
  contentStyles,
  filterButtonGroupWrapper,
} from "plos/src/components/FilterSheet/FilterRadioButton/filterRadioButton.css";
import { RadioButtonGroup } from "plos/src/components/forms";
import { Sheet } from "plos/src/components/Sheet";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getSelectedOption } from "../../utils";

interface EventFilterProps {
  selectedEventId: number;
  handleFilterChange: (eventId: number) => void;
  startEvent: number | null;
}

const EventFilter = ({
  selectedEventId,
  handleFilterChange,
  startEvent,
}: EventFilterProps) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [unsavedSelectionId, setUnsavedSelectionId] = useState<
    string | undefined
  >(undefined);

  const eventIdAsString = selectedEventId.toString();
  const events = useSelector(getEvents);

  if (!startEvent) {
    return null;
  }

  const formattedEvents = [
    { value: "0", label: t("allGameweeks", "All Gameweeks") },
    ...events
      .filter((e) => e.id >= startEvent)
      .map(({ id, name, is_current: isCurrent }) => ({
        value: id.toString(),
        label: isCurrent ? `${name} - ${t("current", "current")}` : name,
      })),
  ];

  const selectedEntry = getSelectedOption({
    filterOptions: formattedEvents,
    selectedOption: selectedEventId,
  });

  const handleClose = () => {
    setOpen(false);
    setUnsavedSelectionId(undefined);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const isSaveButtonDisabled =
    unsavedSelectionId == null || eventIdAsString == unsavedSelectionId;

  const handleSave = () => {
    if (!unsavedSelectionId) return;
    handleFilterChange(parseInt(unsavedSelectionId, 10));
    setUnsavedSelectionId(undefined);
    handleClose();
  };

  return (
    <>
      <FilterChip
        label={t("gameweek", "Gameweek") as string}
        selectedOption={[selectedEntry]}
        onClick={handleOpen}
      />
      <Sheet
        headerSize="xl"
        title={t("gameweeks", "Gameweeks")}
        open={open}
        handleClose={handleClose}
        footer={
          <FilterFooter
            isDisabled={isSaveButtonDisabled}
            handleSave={handleSave}
            handleClose={handleClose}
          />
        }
      >
        <div className={filterButtonGroupWrapper}>
          <div className={contentStyles}>
            <RadioButtonGroup
              label={t("teams", "Teams")}
              value={unsavedSelectionId ?? eventIdAsString}
              onChange={(id) => setUnsavedSelectionId(id)}
              hideLabel
            >
              {formattedEvents.map(({ value, label }) => (
                <FilterRadioButton key={value} value={value}>
                  {label}
                </FilterRadioButton>
              ))}
            </RadioButtonGroup>
          </div>
        </div>
      </Sheet>
    </>
  );
};

export default EventFilter;
